export default __webpack_public_path__ + "static/media/scotiabank-marked.1ffec41d.png";